import TaskColumn from './TaskColumn';
import React from "react";
import 'array.prototype.move';
import { DragDropContext } from 'react-beautiful-dnd';
import './styles/TaskView.css';

const TaskView = ({user, setUser}) => {

    // Generate sections based off of user's tasks.
    const sections = {
        notStarted : {
            tasks: user.tasks["notStarted"],
            title: "Not Started",
            id: "notStarted"
        },
        prevIP : {
            tasks: user.tasks["prevIP"],
            title: "Previously In Progress",
            id: "prevIP"
        },
        inProgress : {
            tasks: user.tasks["inProgress"],
            title: "In Progress",
            id: "inProgress"
        },
        complete : {
            tasks: user.tasks["complete"],
            title: "Complete",
            id: "complete"
        }
    }

    // Update     
    const updateTask = async (source , destination, task) => {
        // Create date stamp - verify data date.
        let newDate = new Date()
        let date = newDate.getDate();
        let month = newDate.getMonth() + 1;
        let year = newDate.getFullYear();
        const dateStamp = `${month<10?`0${month}`:`${month}`}-${date<10?`0${date}`:`${date}`}-${year}`
        if (dateStamp !== user.lastLogin) {
            alert('Session Expired. Please sign in again.')
            setUser(null)
            return
        }
        const res = await fetch('https://GradientBack.3-sigma.repl.co/update-grid', {
            method: 'PUT',
            headers: {
                'Content-type': 'application/json',
            },
            body: JSON.stringify({
                    sessionToken: user.sessionToken,
                    username: user.name,
                    oldStatus: source.droppableId,
                    newStatus: destination.droppableId,
                    oldIndex: source.index,
                    newIndex: destination.index,
                    task: task})
        })
        if (res.status === 401) {
            alert('Session Expired. Signed in on another device.')
            setUser(null)
        }
        else if (res.status !== 204) {
            alert('Something went wrong while updating the task.', res.status)
        }
    }
    
    const onDragEnd = ({ source, destination }) => {
        if (destination === undefined || destination === null) {
            return null
        }
        if (source.droppableId === destination.droppableId && destination.index === source.index) {
            return null
        }
        // Set start and end lists
        const start = sections[source.droppableId]
        const end = sections[destination.droppableId]
        
        const updatedTask = start.tasks[source.index]
        if (start === end) {
            start.tasks.move(source.index, destination.index)
        }
        else {
            updatedTask.status = destination.droppableId
            if (updatedTask.status === "Complete") {
                let newDate = new Date()
                let date = newDate.getDate();
                let month = newDate.getMonth() + 1;
                let year = newDate.getFullYear();
                updatedTask.completionDate = `${month<10?`0${month}`:`${month}`}-${date<10?`0${date}`:`${date}`}-${year}`
            } else {
                updatedTask.completionDate = ""
            }
            end.tasks.push(updatedTask)
            end.tasks.move(-1, destination.index)
            start.tasks.splice(source.index, 1)
        }
        updateTask(source, destination, updatedTask)
        return null
    }

    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <div className='taskGrid'>
                <div>
                    <TaskColumn section={sections.notStarted} key={sections.notStarted.id} user={user} setUser={setUser}/>
                    <TaskColumn section={sections.prevIP} key={sections.prevIP.id} user={user} setUser={setUser}/>
                </div>
                <TaskColumn section={sections.inProgress} key={sections.inProgress.id} user={user} setUser={setUser}/>
                <TaskColumn section={sections.complete} key={sections.complete.id} user={user} setUser={setUser}/>
            </div>
        </DragDropContext>
    )
}

export default TaskView
